import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { ChartContainer, ChartTooltipContent, ChartLegendContent } from '../components/Chart';
import { BarChart, Bar, XAxis, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, ResponsiveContainer } from 'recharts';
import { FileText, Receipt, Send, MessageSquare, CheckCircle, Target, ThumbsUp, Clock } from 'lucide-react';
const kpiData = [{
  title: 'Discharge Summaries Generated',
  value: '311',
  icon: FileText,
  color: '#3B82F6',
  data: [10, 25, 15, 30, 20, 40, 35]
}, {
  title: 'Billing Sheets Created',
  value: '298',
  icon: Receipt,
  color: '#14B8A6',
  data: [15, 20, 25, 22, 30, 28, 35]
}, {
  title: 'Insurance Submissions Made',
  value: '276',
  icon: Send,
  color: '#8B5CF6',
  data: [5, 15, 10, 25, 20, 30, 25]
}, {
  title: 'Queries Auto-Resolved',
  value: '43',
  icon: MessageSquare,
  color: '#22C55E',
  data: [2, 5, 3, 8, 6, 12, 10]
}, {
  title: 'Overall Success Rate',
  value: '98%',
  icon: CheckCircle,
  color: '#22C55E',
  data: [95, 96, 95, 97, 98, 98, 98]
}, {
  title: 'Avg. Billing Accuracy',
  value: '96.4%',
  icon: Target,
  color: '#C8892A',
  data: [92, 93, 94, 95, 94, 96, 96.4]
}, {
  title: 'Claims Accepted (First Pass)',
  value: '89%',
  icon: ThumbsUp,
  color: '#F97316',
  data: [80, 82, 85, 84, 87, 88, 89]
}, {
  title: 'Time Saved per Patient',
  value: '2.1 hrs',
  icon: Clock,
  color: '#EF4444',
  data: [1.5, 1.6, 1.8, 1.7, 1.9, 2.0, 2.1]
}];
const pipelineVolumeData = [{
  date: '18/03',
  discharge: 20,
  billing: 18,
  insurance: 15,
  query: 2
}, {
  date: '19/03',
  discharge: 25,
  billing: 22,
  insurance: 20,
  query: 3
}, {
  date: '20/03',
  discharge: 22,
  billing: 20,
  insurance: 18,
  query: 1
}, {
  date: '21/03',
  discharge: 30,
  billing: 28,
  insurance: 25,
  query: 4
}, {
  date: '22/03',
  discharge: 28,
  billing: 25,
  insurance: 22,
  query: 3
}, {
  date: '23/03',
  discharge: 35,
  billing: 32,
  insurance: 28,
  query: 5
}, {
  date: '24/03',
  discharge: 32,
  billing: 30,
  insurance: 26,
  query: 4
}, {
  date: '25/03',
  discharge: 40,
  billing: 38,
  insurance: 35,
  query: 6
}, {
  date: '26/03',
  discharge: 38,
  billing: 35,
  insurance: 32,
  query: 5
}, {
  date: '27/03',
  discharge: 45,
  billing: 42,
  insurance: 38,
  query: 7
}, {
  date: '28/03',
  discharge: 42,
  billing: 40,
  insurance: 36,
  query: 6
}, {
  date: '29/03',
  discharge: 50,
  billing: 48,
  insurance: 45,
  query: 8
}, {
  date: '30/03',
  discharge: 48,
  billing: 45,
  insurance: 42,
  query: 7
}, {
  date: '31/03',
  discharge: 55,
  billing: 52,
  insurance: 48,
  query: 9
}];
const pipelineConfig = {
  discharge: {
    label: 'Discharge Summary',
    color: '#3B82F6'
  },
  billing: {
    label: 'Billing Sheet',
    color: '#14B8A6'
  },
  insurance: {
    label: 'Insurance Submission',
    color: '#8B5CF6'
  },
  query: {
    label: 'Query Resolution',
    color: '#C8892A'
  }
};
const outcomesData = [{
  name: 'Accepted',
  value: 245,
  color: '#22C55E'
}, {
  name: 'Disputed',
  value: 15,
  color: '#C8892A'
}, {
  name: 'Pending',
  value: 12,
  color: '#64748B'
}, {
  name: 'Resolved',
  value: 4,
  color: '#166534'
}];
const outcomesConfig = {
  accepted: {
    label: 'Accepted',
    color: '#22C55E'
  },
  disputed: {
    label: 'Disputed',
    color: '#C8892A'
  },
  pending: {
    label: 'Pending',
    color: '#64748B'
  },
  resolved: {
    label: 'Resolved',
    color: '#166534'
  }
};
export function Dashboard() {
  return <div className="p-8 max-w-[1600px] mx-auto space-y-8" data-id="element-152">
      <div data-id="element-153">
        <h1 className="font-heading text-4xl font-normal text-foreground mb-2" data-id="element-154">
          Dashboard
        </h1>
        <p className="text-muted-foreground text-lg" data-id="element-155">
          Monitor your billing and insurance automations
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-156">
        {kpiData.map((kpi, i) => <Card key={i} className="overflow-hidden" data-id="element-157">
            <CardContent className="p-6" data-id="element-158">
              <div className="flex justify-between items-start mb-4" data-id="element-159">
                <span className="text-sm font-medium text-muted-foreground" data-id="element-160">
                  {kpi.title}
                </span>
                <div className="p-2 rounded-full bg-secondary" data-id="element-161">
                  <kpi.icon className="w-4 h-4 text-foreground" data-id="element-162" />
                </div>
              </div>
              <div className="flex items-end justify-between" data-id="element-163">
                <div data-id="element-164">
                  <div className="font-heading text-4xl font-normal text-foreground" data-id="element-165">
                    {kpi.value}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1" data-id="element-166">
                    Last 14 days
                  </div>
                </div>
                <div className="h-12 w-24" data-id="element-167">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-168">
                    <LineChart data={kpi.data.map((val, idx) => ({
                  val,
                  idx
                }))} data-id="element-169">
                      <Line type="monotone" dataKey="val" stroke={kpi.color} strokeWidth={2} dot={false} isAnimationActive={false} data-id="element-170" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-171">
        <Card className="lg:col-span-2" data-id="element-172">
          <CardHeader data-id="element-173">
            <CardTitle className="font-heading text-xl font-normal" data-id="element-174">
              Agent Pipeline Volume
            </CardTitle>
          </CardHeader>
          <CardContent data-id="element-175">
            <div className="h-[300px]" data-id="element-176">
              <ChartContainer config={pipelineConfig} data-id="element-177">
                <BarChart data={pipelineVolumeData} margin={{
                top: 20,
                right: 0,
                left: -20,
                bottom: 0
              }} data-id="element-178">
                  <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B6560'
                }} dy={10} data-id="element-179" />
                  <Tooltip content={<ChartTooltipContent data-id="element-181" />} cursor={{
                  fill: 'rgba(0,0,0,0.05)'
                }} data-id="element-180" />
                  <Legend content={<ChartLegendContent data-id="element-183" />} verticalAlign="top" data-id="element-182" />
                  <Bar dataKey="discharge" stackId="a" fill="var(--color-discharge)" radius={[0, 0, 4, 4]} data-id="element-184" />
                  <Bar dataKey="billing" stackId="a" fill="var(--color-billing)" data-id="element-185" />
                  <Bar dataKey="insurance" stackId="a" fill="var(--color-insurance)" data-id="element-186" />
                  <Bar dataKey="query" stackId="a" fill="var(--color-query)" radius={[4, 4, 0, 0]} data-id="element-187" />
                </BarChart>
              </ChartContainer>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-188">
          <CardHeader data-id="element-189">
            <CardTitle className="font-heading text-xl font-normal" data-id="element-190">
              Insurance Claim Outcomes
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col items-center justify-center h-[300px] relative" data-id="element-191">
            <ChartContainer config={outcomesConfig} className="w-full h-full" data-id="element-192">
              <PieChart data-id="element-193">
                <Pie data={outcomesData} cx="50%" cy="50%" innerRadius={80} outerRadius={110} paddingAngle={2} dataKey="value" stroke="none" data-id="element-194">
                  {outcomesData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-195" />)}
                </Pie>
                <Tooltip content={<ChartTooltipContent data-id="element-197" />} data-id="element-196" />
                <Legend content={<ChartLegendContent data-id="element-199" />} verticalAlign="bottom" data-id="element-198" />
              </PieChart>
            </ChartContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none pb-8" data-id="element-200">
              <span className="font-heading text-4xl font-normal text-foreground" data-id="element-201">
                276
              </span>
              <span className="text-xs text-muted-foreground" data-id="element-202">
                Total Submissions
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}